import type { en } from './en.js';

export const ru: typeof en = {
  app: {
    name: 'Шахматы',
  },
  seo: {
    title:
      'Шахматы онлайн бесплатно — с ботом или с другом | BN-games',
    description:
      'Играйте в шахматы бесплатно в браузере — с ботом четырёх уровней, с другом на одном устройстве или онлайн по коду комнаты. Шахматные часы по желанию, экспорт PGN. Без регистрации.',
    social:
      'Шахматы в браузере. Играйте с ботом, с другом на одном устройстве или онлайн по коду комнаты.',
    h1:
      'Шахматы онлайн — с ботом или с другом',
    intro:
      'В шахматы играют вдвоём на доске 8×8, и у каждого игрока в начале шестнадцать фигур: король, ферзь, две ладьи, два слона, два коня и восемь пешек. Цель — поставить мат королю соперника, то есть атаковать его так, чтобы ему некуда было уйти.\n\nНа BN-games действуют стандартные правила ФИДЕ — с рокировкой, взятием на проходе, превращением пешки и всеми правилами ничьей. Играйте бесплатно в браузере с ботом, с другом на одном устройстве или онлайн по коду комнаты — с часами или без.',
    rulesTitle:
      'Правила шахмат — как ходят фигуры, рокировка, мат | BN-games',
    rulesDescription:
      'Как играть в шахматы: доска, ходы каждой фигуры, рокировка, взятие на проходе, превращение пешки, шах и мат, все виды ничьей — и сразу играть онлайн бесплатно.',
    rulesH1:
      'Правила игры в шахматы',
    playCta:
      'Играть в шахматы',
  },
  auth: {
    signIn: 'Войти',
    signOut: 'Выйти',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Заполните профиль →',
    profile: 'Профиль',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Закрыть',
    invite: {
      message: '{{sender}} приглашает вас в {{game}}',
      moreCount_one: '+{{count}} ещё приглашение',
      moreCount_few: '+{{count}} ещё приглашения',
      moreCount_many: '+{{count}} ещё приглашений',
      moreCount_other: '+{{count}} ещё приглашений',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptAria: 'Принять приглашение от {{sender}} в {{game}}',
      declineAria: 'Отклонить приглашение от {{sender}} в {{game}}',
    },
    dock: {
      pillLabel: 'От {{sender}}',
      pillAria: 'Приглашение от {{sender}} в {{game}} — показать',
      popoverLabel: 'Приглашение',
      close: 'Закрыть приглашение',
      leaveGameTitle: 'Покинуть игру?',
      leaveGameBody: 'Приглашение откроет {{game}}, а текущая партия будет прервана. В онлайн-игре ваше место какое-то время сохраняется — вы сможете вернуться.',
      leaveGameConfirm: 'Выйти и присоединиться',
      leaveGameCancel: 'Остаться',
    },
    friendPicker: {
      button: 'Пригласить друга',
      modalTitle: 'Пригласить друга',
      loading: 'Загрузка друзей…',
      signInPrompt: 'Войдите, чтобы пригласить друга.',
      empty: 'У вас пока нет друзей.',
      findFriends: 'Найти друзей',
      invite: 'Пригласить',
      inviteAria: 'Пригласить {{name}}',
      invited: 'Приглашён',
      invitedAria: '{{name}} приглашён',
      notAccepting: 'Этот игрок сейчас не принимает приглашения',
      retryIn: 'Повторите через {{seconds}} с',
    },
    addOpponent: {
      buttonMany: 'Добавить друзей…',
      modalTitle: 'Добавить друзей',
      add: 'Добавить {{name}} в друзья',
      added: 'Добавлен',
      addedAria: '{{name}} добавлен в друзья',
    },
  },
  mainMenu: {
    quickStart: 'Быстрый старт',
    newGame: 'Новая игра',
    rules: 'Правила',
    settings: 'Настройки',
    history: 'История игр',
    about: 'Об игре',
  },
  online: {
    create: {
      title: 'Создать комнату',
      sideLabel: 'Ваш цвет',
      clockLabel: 'Контроль времени',
      noClock: 'Без часов',
      codeLabel: 'Код комнаты',
      share: 'Поделитесь этим кодом с соперником',
      clockInfo: 'Контроль времени: {{clock}}',
      create: 'Создать',
    },
    share: {
      copyCode: 'Скопировать код',
      copyLink: 'Скопировать ссылку',
      copied: 'Скопировано!',
    },
    join: {
      title: 'Войти в комнату',
      codeLabel: 'Введите код комнаты',
      typeHint: 'Введите код из {{count}} символов',
      enterHint: 'Нажмите Enter, чтобы войти',
      submit: 'Войти',
      paste: 'Вставить',
    },
    errors: {
      roomNotFound: 'Комнаты с таким кодом нет.',
      roomFull: 'В этой комнате уже нет мест.',
      roomExpired: 'Эта комната закрыта.',
      connectionLost: 'Соединение потеряно. Проверьте сеть и попробуйте ещё раз.',
    },
    status: {
      connecting: 'Соединение',
      creating: 'Создание комнаты',
      waitingForOpponent: 'Ожидание соперника',
      opponentJoined: 'Соперник присоединился',
      joining: 'Подключение',
      couldNotJoin: 'Не удалось войти',
      error: 'Ошибка соединения',
    },
    banner: {
      opponentAway: '{{name}} отключился',
    },
    draw: {
      pending: 'Ничья предложена…',
      declined: 'Ничья отклонена',
      offeredTitle: 'Предложена ничья',
      offeredBody: '{{name}} предлагает ничью.',
    },
    restart: {
      title: 'Предложен рестарт',
      body: '{{name}} предлагает начать партию заново.',
      accept: 'Начать заново',
    },
    overlay: {
      reconnecting: 'Переподключение',
      restoringGame: 'Восстановление игры {{countdown}}',
      connectionLost: 'Связь потеряна',
      gameEnded: 'Игра завершена',
      rematchOffered: 'Предложен реванш',
      waitingForOpponent: 'Ожидание {{name}}',
      rematchRequested: '{{name}} предлагает реванш',
      rematchDeclined: '{{name}} отказался от реванша',
      buttons: {
        leave: 'Выйти',
        rematch: 'Реванш',
        returnToMenu: 'Меню',
        cancel: 'Отмена',
        accept: 'Принять',
        decline: 'Отклонить',
      },
    },
    resumeModal: {
      reconnectingTitle: 'Переподключение…',
      reconnectingBody: 'Возвращаемся в игру…',
      seatTakenTitle: 'Место занято',
      seatTakenBody: 'Это место принадлежит другому аккаунту. Войдите под тем аккаунтом или начните новую игру.',
      roomGoneTitle: 'Стол закрыт',
      roomGoneBody: 'Эта партия завершена — стол закрыт.',
      roomFullTitle: 'Комната заполнена',
      roomFullBody: 'Все места за этим столом заняты, и ни одно из них не ваше.',
      anonymousTitle: 'Не можем подтвердить, что это место ваше',
      anonymousBody: 'В этом браузере нет записи об этой игре. Войдите в аккаунт перед следующей онлайн-игрой, и ваше место будет доступно с любого устройства.',
      unreachableTitle: 'Не удалось связаться с сервером',
      unreachableBody: 'Сервер не отвечает. Проверьте соединение и попробуйте снова.',
      signIn: 'Войти',
      viewSaved: 'Посмотреть сохранённую позицию',
      retry: 'Повторить',
      discard: 'Удалить',
    },
  },
  historyList: {
    title: 'История партий',
    empty: 'Сохранённых партий пока нет — сыграйте, чтобы начать список.',
    vsTemplate: '{{white}} — {{black}}',
    winnerTemplate: 'Победа: {{name}}',
    draw: 'Ничья',
    movesCount_one: '{{count}} ход',
    movesCount_few: '{{count}} хода',
    movesCount_many: '{{count}} ходов',
    movesCount_other: '{{count}} хода',
    deleteAria: 'Удалить партию',
    deleteConfirm: 'Удалить эту сохранённую партию?',
    botName: 'Бот ({{level}})',
    modes: {
      bot: 'Против бота',
      local: 'Локально',
      online: 'По сети',
    },
    accountSection: {
      title: 'Ваш аккаунт',
      loading: 'Загрузка…',
      empty: 'Пока нет онлайн-партий.',
      statsLine: '{{wins}}В – {{losses}}П – {{draws}}Н ({{played}} сыграно)',
    },
    deviceSection: {
      title: 'На этом устройстве',
    },
    unreadableTitle: 'Эту партию не удаётся открыть',
    unreadableBody: 'Сохранённая запись не воспроизводится, показать нечего.',
  },
  moveList: {
    title: 'Ходы',
    empty: 'Ходов пока нет',
    expand: 'Показать все ходы',
    collapse: 'Показать одну строку ходов',
    goTo: 'Перейти к ходу {{move}}',
    materialEven: 'Материал: поровну',
    materialLead: 'Материал: {{side}} +{{points}}',
    captures: 'Взятия: {{white}} – {{black}}',
  },
  exportGame: {
    label: 'Экспорт партии',
    copyPgn: 'Копировать PGN',
    downloadPgn: 'Скачать PGN',
    copyFen: 'Копировать FEN',
    copied: 'Скопировано!',
  },
  importPosition: {
    title: 'Импорт позиции',
    hint: 'Вставьте позицию в FEN или партию в PGN. Партия из PGN продолжится с последнего хода.',
    inputLabel: 'FEN или PGN',
    paste: 'Вставить',
    playBot: 'Играть с ботом',
    playHuman: 'Играть с человеком',
    readyWhite: 'Готово — ход {{move}}, ходят белые.',
    readyBlack: 'Готово — ход {{move}}, ходят чёрные.',
    errors: {
      empty: 'Сначала вставьте FEN или PGN.',
      fen: 'Это некорректная позиция FEN.',
      pgn: 'Не удалось прочитать этот PGN.',
      over: 'Эта партия уже окончена — играть больше нечего.',
    },
  },
  replay: {
    controls: {
      first: 'В начало',
      previous: 'Назад',
      play: 'Играть',
      pause: 'Пауза',
      next: 'Вперёд',
      last: 'В конец',
      speed: 'Скорость',
      backToHistory: 'К списку',
      backToMenu: 'В меню',
    },
  },
  common: {
    back: '← Назад',
    opponent: 'Соперник',
    white: 'Белые',
    black: 'Чёрные',
    cycle: 'нажмите Enter для смены',
  },
  gameOverlay: {
    title: 'Пауза',
    settingsLabel: 'Настройки',
    settingsBackLabel: '← Назад',
    settingsViewTitle: 'Настройки',
    restartLabel: 'Сыграть заново',
    restartHintOnline: 'Онлайн: нужно согласие всех. Одно предложение за партию.',
    restartHintAlreadyProposed: 'Вы уже предлагали рестарт в этой партии.',
    restartHintPending: 'Ждём ответа другого игрока…',
    returnToMenuLabel: 'В главное меню',
    returnToMenuConfirmTitle: 'Выйти из партии и вернуться в меню?',
    returnToMenuConfirmYes: 'Да, выйти',
    returnToMenuConfirmNo: 'Остаться',
    giveUpLabel: 'Сдаться',
    giveUpConfirmTitle: 'Точно сдаёшься, трус?',
    giveUpConfirmYes: 'Да, я трус',
    giveUpConfirmNo: 'Продолжу борьбу',
    settingsTabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
      audio: 'Звук',
    },
    discardConfirmTitle: 'Прервать текущую партию?',
    discardConfirmBody: 'Изменение этой настройки завершит текущую игру и начнёт новую.',
    discardConfirmYes: 'Прервать и начать заново',
    discardConfirmNo: 'Отмена',
    close: 'Закрыть',
  },
  playMenu: {
    title: 'Игра',
    vsAi: 'Против бота',
    vsHuman: 'Против человека (локально)',
    createOnline: 'Создать онлайн-игру',
    joinOnline: 'Присоединиться к игре',
    importPosition: 'Импорт позиции (FEN / PGN)',
    resumeOnline: 'Продолжить онлайн ({{code}})',
    resumeOnlineVs: 'Продолжить онлайн · против {{opponent}}',
  },
  settings: {
    title: 'Настройки',
    tabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
      audio: 'Звук',
    },
    rows: {
      playerName: 'Имя игрока',
      sound: 'Звук',
      difficulty: 'Сложность',
      defaultColor: 'Цвет по умолчанию',
      theme: 'Оформление',
      language: 'Язык',
      showValidMoves: 'Показывать возможные ходы',
      showMoveList: 'Показывать список ходов',
      afkAssistEnabled: 'Подсказка хода при бездействии',
      afkRemindersEnabled: 'Звук напоминания AFK',
      turnStartSound: 'Звук начала хода',
      clockEnabled: 'Шахматные часы',
      clockPreset: 'Контроль времени',
      flipBoard: 'Поворачивать доску после хода (2 игрока)',
      showAfkPingButton: 'Показывать кнопку «пинг»',
    },
    difficulties: {
      easy: 'Лёгкий',
      normal: 'Обычный',
      hard: 'Сложный',
      expert: 'Эксперт',
    },
    colors: {
      white: 'Белые',
      black: 'Чёрные',
      random: 'Случайный',
    },
    clockPresets: {
      bullet: 'Пуля · 1 мин',
      blitz: 'Блиц · 5 мин',
      rapid: 'Рапид · 10 мин',
    },
    themes: {
      mahogany: 'Mahogany',
      persian: 'Persian',
      deco: 'Deco',
      monte: 'Monte',
    },
    languages: {
      en: 'English',
      ru: 'Русский',
    },
    on: 'Вкл',
    off: 'Выкл',
    namePrompt: 'Введите ваше имя:',
  },
  about: {
    version: 'Версия {{version}}',
    tech: 'TypeScript + Canvas',
    body: 'Классические шахматы по правилам ФИДЕ — с ботом или с другом.',
  },
  game: {
    banner: {
      toMove: 'Ход: {{side}}',
      toMoveCheck: 'Ход: {{side}} — шах!',
      yourMove: 'Ваш ход',
      yourMoveCheck: 'Ваш ход — шах!',
      botThinking: 'Бот думает…',
      wins: '{{side}} побеждают',
      youWin: 'Вы победили!',
      youLose: 'Вы проиграли',
      draw: 'Ничья',
    },
    termination: {
      checkmate: 'Мат',
      stalemate: 'Пат',
      insufficient: 'Недостаточно материала',
      threefold: 'Троекратное повторение',
      fiftyMove: 'Правило 50 ходов',
      resign: 'Сдача',
      agreement: 'Ничья по соглашению',
      flag: 'Закончилось время',
    },
    draw: {
      offer: 'Предложить ничью',
      hotSeatTitle: 'Предложение ничьей',
      hotSeatBody: '{{side}} предлагают ничью. {{other}} согласны?',
      accept: 'Согласиться',
      decline: 'Играть дальше',
      botDeclined: 'Бот отклоняет ничью.',
    },
    gameOver: {
      win: 'Вы победили!',
      loss: 'Вы проиграли',
      draw: 'Ничья',
      sideWins: '{{side}} побеждают',
      playAgain: 'Сыграть ещё',
      menu: 'Главное меню',
    },
    pingOpponent: 'Позвать соперника',
    tooltips: {
      pause: 'Меню паузы',
      hideMoveList: 'Скрыть список ходов',
      showMoveList: 'Показать список ходов',
    },
  },
  promotion: {
    title: 'Превратить пешку в',
    queen: 'Ферзя',
    rook: 'Ладью',
    bishop: 'Слона',
    knight: 'Коня',
    cancel: 'Отмена',
  },
  a11y: {
    canvasLabel: 'Шахматная доска. Стрелки перемещают курсор по полям, Enter берёт фигуру, повторный Enter делает ход.',
  },
  narration: {
    sides: {
      white: 'Белые',
      black: 'Чёрные',
    },
    pieces: {
      pawn: 'пешка',
      knight: 'конь',
      bishop: 'слон',
      rook: 'ладья',
      queen: 'ферзь',
      king: 'король',
    },
    piecesTaken: {
      pawn: 'пешку',
      knight: 'коня',
      bishop: 'слона',
      rook: 'ладью',
      queen: 'ферзя',
      king: 'короля',
    },
    move: '{{side}}: {{piece}} с {{from}} на {{to}}.',
    capture: '{{side}}: {{piece}} с {{from}} бьёт {{captured}} на {{to}}.',
    castleKing: '{{side}}: короткая рокировка.',
    castleQueen: '{{side}}: длинная рокировка.',
    promotion: 'Превращение: {{piece}}.',
    check: 'Шах.',
    gameOver: '{{result}}. {{reason}}.',
    cursor: {
      empty: '{{square}}',
      piece: '{{square}}, {{side}}: {{piece}}',
      legal: '{{square}}, можно пойти',
      capture: '{{square}}, взятие: {{piece}}',
    },
    selected: 'Выбрана фигура: {{piece}} на {{square}}.',
    deselected: 'Выбор снят.',
  },
  rules: {
    screenTitle: 'Правила',
    fide: {
      title: 'Классические шахматы (правила ФИДЕ)',
      items: {
        setup: {
          title: 'Расстановка',
          body: 'На доске 64 поля; её кладут так, чтобы у каждого игрока справа в углу было белое поле. Ладьи стоят в углах, рядом кони, затем слоны; ферзь стоит на поле своего цвета (белый на d1, чёрный на d8), король — рядом с ним. Восемь пешек каждой стороны занимают ряд перед фигурами. Первыми ходят белые, дальше игроки ходят по очереди.',
        },
        king: {
          title: 'Король',
          body: 'Король ходит на одно поле в любом направлении. Ему нельзя вставать на поле, которое атакует фигура соперника.',
        },
        queen: {
          title: 'Ферзь',
          body: 'Ферзь ходит на любое число полей по прямой — по горизонтали, вертикали или диагонали, — но не перепрыгивает через другие фигуры.',
        },
        rook: {
          title: 'Ладья',
          body: 'Ладья ходит на любое число полей по горизонтали или вертикали, не перепрыгивая через фигуры.',
        },
        bishop: {
          title: 'Слон',
          body: 'Слон ходит на любое число полей по диагонали, не перепрыгивая через фигуры, поэтому всю партию остаётся на полях одного цвета.',
        },
        knight: {
          title: 'Конь',
          body: 'Конь ходит буквой «Г»: на два поля в одном направлении и на одно в сторону. Это единственная фигура, которая перепрыгивает через другие.',
        },
        pawn: {
          title: 'Пешка',
          body: 'Пешка ходит прямо вперёд на одно поле, а с начальной позиции — на одно или два, если оба поля свободны. Бьёт пешка иначе: на одно поле вперёд по диагонали. Назад пешки не ходят.',
        },
        capture: {
          title: 'Взятие',
          body: 'Фигура бьёт, вставая на поле, занятое фигурой соперника; побитая фигура снимается с доски. Бить не обязательно.',
        },
        castling: {
          title: 'Рокировка',
          body: 'Один раз за партию король может пойти на два поля в сторону ладьи, а ладья перепрыгивает на поле, через которое прошёл король. Это можно сделать, только если ни король, ни эта ладья ещё не ходили, поля между ними свободны, король не под шахом, не проходит через атакованное поле и не встаёт на него.',
        },
        enPassant: {
          title: 'Взятие на проходе',
          body: 'Если пешка ходит на два поля и встаёт рядом с пешкой соперника, та может побить её так, будто она сходила лишь на одно поле. Сделать это можно только сразу, следующим же ходом, иначе право пропадает.',
        },
        promotion: {
          title: 'Превращение пешки',
          body: 'Пешка, дошедшая до последнего ряда, обязательно превращается в ферзя, ладью, слона или коня своего цвета — по выбору игрока, независимо от того, какие фигуры уже есть на доске.',
        },
        check: {
          title: 'Шах',
          body: 'Король, которого атакуют, находится под шахом. Игрок обязан сразу защититься — увести короля, побить атакующую фигуру или закрыться. Ход, после которого ваш король остаётся под шахом, делать нельзя.',
        },
        checkmate: {
          title: 'Мат',
          body: 'Если королю объявлен шах и защититься от него нечем, это мат, и игрок проигрывает. Сдаться можно в любой момент.',
        },
        stalemate: {
          title: 'Пат',
          body: 'Если у игрока, чья очередь ходить, король не под шахом, но нет ни одного допустимого хода, это пат — партия заканчивается вничью.',
        },
        draws: {
          title: 'Другие ничьи',
          body: 'Ничья также наступает, когда ни у одной стороны не осталось материала для мата (например, король против короля или король со слоном против короля), когда одна и та же позиция повторилась трижды при том же игроке на ходу, когда за пятьдесят ходов каждой стороны подряд не было ни хода пешкой, ни взятия, или когда оба игрока согласились на ничью.',
        },
        clock: {
          title: 'Игра с часами',
          body: 'С часами у каждого игрока есть фиксированное время на всю партию, и идут только часы того, чья очередь ходить. Игрок, у которого закончилось время, проигрывает — если только у соперника не осталось возможности поставить мат: тогда это ничья.',
        },
      },
    },
  },
  pwa: {
    updateAvailable: {
      title: 'Доступно обновление',
      body: 'Новая версия «Шахмат» готова. Обновите страницу, чтобы загрузить её.',
      refresh: 'Обновить',
      later: 'Позже',
    },
  },
};
